module.exports = __webpack_public_path__ + "img/quick-start-guide_ms.5298413b.jpg";